import { sumBy } from 'lodash';

import { ProcedureTableBean } from './procedures.types';

export const MIN_QUANTITY = 1;
export const MAX_QUANTITY = 50;

// Temporary workaround waiting for new draft mechanism
export const safeProcedureQuantity = (quantity: number | null): number => {
   if (!quantity) {
      return MIN_QUANTITY;
   }

   return Math.max(0, Math.min(quantity, MAX_QUANTITY));
};

export const validProcedureCount = (value: ProcedureTableBean[]): boolean => {
   return MAX_QUANTITY >= sumBy(value, (procedure) => procedure.quantity);
};

export const procedureLimitReached = (value: ProcedureTableBean[]): boolean => {
   return sumBy(value, (procedure) => procedure.quantity) >= MAX_QUANTITY;
};
